export default "__VITE_ASSET__1b8a80a4__"